<div class="status-message-list scrollarea">
  @for (statusEvent of statusEventDetails; track statusEvent) {
    <div>
      <div class="status-message">
        <div class="row mb-1" [ngClass]="getWidgetItemClass(statusEvent)">
          <div class="col text-left">
            <div class="d-flex align-items-center">
              <div class="status-icon-sm text-{{getType(statusEvent)}}">
                <i class="fa mr-2"
                  [ngClass]="getClass(statusEvent)"
                ></i>
              </div>
              <div class="d-flex flex-column">
                <strong [innerHTML]="statusEvent.signalName"></strong>
                <small class="text-muted" [innerHTML]="statusEvent.signalLabel | translate"></small>
              </div>
            </div>
          </div>
          <div class="col text-left">
            <p class="pl-1 mb-0" [innerText]="getDescription(statusEvent)"></p>
          </div>
          <div class="col text-left">
            <span class="text-muted" [innerText]="statusEvent.timestamp | date:'medium'"></span>
          </div>
        </div>
      </div>
    </div>
  }
</div>